import React from 'react';
import { APP_PLATFORM } from 'libs/constants';
import LoginRequired from './LoginRequired';

export default function LoginRequiredAccountsWeb(props) {
  return (
    <LoginRequired
      platform={APP_PLATFORM.web}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/RouteWrappers/LoginRequiredAccountsWeb.jsx